<template>
  <div>
    <el-form
        ref="form"
        :model="localModel"
        :rules="localRules"
    >
      <table>
        <tr>
          <td class="title">實習生姓名</td>
          <td class="content">
            {{ info.studentName }}
          </td>
          <td class="title">系（所）</td>
          <td class="content">
            {{ info.sectionName }}
          </td>
          <td class="title">訪談日期</td>
          <td class="content">
            <el-form-item
                prop="interviewDate"
                style="display: inline-block;"
            >
              <el-date-picker
                  v-model="localModel['interviewDate']"
                  :disabled="readonly"
                  :format="formDefs['interviewDate'].prop.format"
                  :placeholder="formDefs['interviewDate'].placeholder"
                  :size="size"
                  :value-format="formDefs['interviewDate'].prop.valueFormat"
              ></el-date-picker>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="title">實習機構名稱</td>
          <td class="content" colspan="5">
            {{ info.vendorName }}
          </td>
        </tr>
        <tr>
          <td class="title">訪談方式</td>
          <td class="content" colspan="5">
            <el-form-item
                prop="interviewManners"
                style="display: inline-block;"
            >
              <el-checkbox-group
                  v-model="localModel['interviewManners']"
                  :disabled="readonly"
              >
                <el-checkbox
                    v-for="m in interviewManner"
                    :label="m"
                >
                  {{ m | interviewManner }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="title">校方訪談人</td>
          <td class="content" colspan="5" style="height: 120px">
            <el-form-item
                :label="formDefs['interviewer'].label"
                prop="interviewer"
                style="display: inline-block;margin-right: 10px;"
            >
              <el-input
                  v-model="localModel['interviewer']"
                  :placeholder="formDefs['interviewer'].placeholder"
                  :readonly="readonly"
                  :size="size"
              ></el-input>
            </el-form-item>
            <el-form-item
                :label="formDefs['interviewerJobTitle'].label"
                prop="interviewerJobTitle"
                style="display: inline-block; margin-right: 10px;"
            >
              <el-input
                  v-model="localModel['interviewerJobTitle']"
                  :placeholder="formDefs['interviewerJobTitle'].placeholder"
                  :readonly="readonly"
                  :size="size"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="title" rowspan="2">訪談內容</td>
          <td class="content" colspan="5">
            <div>實習情形及工作表現：</div>
            <el-form-item
                prop="internshipStatus"
                style="display: inline-block; margin-left: 5px;"
            >
              <q-radio-button
                  v-model="localModel['internshipStatus']"
                  :q-options="qOptions.filter(q => q.type === form10QOptionType.InternshipStatus)"
                  :readonly="readonly"
              ></q-radio-button>
            </el-form-item>
            <el-form-item
                :label="formDefs['internshipStatusOther'].label"
                prop="internshipStatusOther"
            >
              <el-input
                  v-model="localModel['internshipStatusOther']"
                  :placeholder="formDefs['internshipStatusOther'].placeholder"
                  :readonly="readonly"
                  :size="size"
                  rows="5"
                  type="textarea"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="content" colspan="5">
            <div>實習生生活現況：</div>
            <el-form-item
                prop="lifeStatus"
                style="display: inline-block; margin-left: 5px;"
            >
              <q-radio-button
                  v-model="localModel['lifeStatus']"
                  :q-options="qOptions.filter(q => q.type === form10QOptionType.LifeStatus)"
                  :readonly="readonly"
              ></q-radio-button>
            </el-form-item>
            <el-form-item
                :label="formDefs['lifeDissatisfied'].label"
                prop="lifeDissatisfied"
            >
              <el-input
                  v-model="localModel['lifeDissatisfied']"
                  :placeholder="formDefs['lifeDissatisfied'].placeholder"
                  :readonly="readonly"
                  :size="size"
                  rows="5"
                  type="textarea"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="content" colspan="6">
            <div>實習輔導教師與學生合照照片上傳(兩張)</div>
            <el-form-item
                :inline-message="true"
                prop="uploads"
            >
              <el-upload
                  ref="upload"
                  :accept="accept"
                  :action="action"
                  :before-remove="(f) => handleBeforeRemove(f)"
                  :before-upload="file => beforeUpload(file, accept, fileSizeLimit, true)"
                  :data="{...dataOptions}"
                  :disabled="readonly"
                  :file-list="defaultUploads"
                  :headers="uploadHeaders"
                  :limit="fileLimit"
                  :on-error="onUploadError"
                  :on-exceed="onExceedLimit"
                  :on-preview="onPreviewShow"
                  :on-success="onUploadSuccess"
                  list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
                <template #tip>
                  <div class="el-upload__tip">
                    檔案不超過5MB(只支援.jpg, .png兩種格式)
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <el-dialog :visible.sync="previewVisible" append-to-body>
      <img :src="previewUrl" alt="" width="100%">
    </el-dialog>
  </div>
</template>

<script>
import defFormDefs from '@/components/Form10/model';
import constantMixin from '@/components/mixins/constantMixin';
import filterMixin from '@/components/mixins/filterMixin';
import detailMixin from '@/components/mixins/detailMixin';
import QRadioButton from '@/components/QRadioButton';
import uploadMixin from  '@/uploadMixin';


const defaultModel = defFormDefs.reduce((obj, f) => ({...obj, [f.key]: f.default}), {id: ''});
const formDefs = defFormDefs.reduce((obj, f) => ({...obj, [f.key]: f}), {});
const defaultRules = defFormDefs.reduce((obj, f) => ({...obj, [f.key]: f.rules}), {});
export default {
  name: 'Form10Detail_1090901',
  components: {QRadioButton},
  data: () => ({
    localModel: {...defaultModel},
    formDefs: {...formDefs},
    localRules: {...defaultRules},
    url: 'upload',
    fileLimit: 2,
    accept: '.jpg,.jpeg,.png',
    previewUrl: '',
    previewVisible: false,
    defaultUploads: [],
    fileSizeLimit: 5242880
  }),

  mixins: [constantMixin, filterMixin, detailMixin, uploadMixin],
  props: {
    info: {
      type: Object,
      required: true
    },

    qOptions: {
      type: Array,
      required: true
    },
  },

  methods: {
    async handleBeforeRemove(file, fileList) {
      if (file.response) {
        await this.beforeRemove(file);
        this.localModel['uploads'] =
            this.localModel['uploads'].filter(f => f.uid !== file.uid);
      } else {
        this.localModel['uploads'] =
            [...this.localModel['uploads'].filter(f => f.key !== file.key)];
      }
    },

    onUploadSuccess(res, file) {
      const {uid} = file;
      this.localModel['uploads'] = [...this.localModel['uploads'], {...res, uid, isNew: true}]
    },

    onPreviewShow(file) {
      this.previewUrl = file.url;
      this.previewVisible = true;
    }
  },

  created() {
    this.defaultUploads = [...this.model['uploads']];
  }

}
</script>

<style scoped>
table,
tr,
td {
  border: 1px solid black;
  border-collapse: collapse;
}

table {
  width: 100%;
}

tr {

}

td {
  padding: 8px;
}

td.title {
  width: 120px;
  color: grey;
}

td.content {
  width: 400px;
  color: black;
}
</style>
